import { useEffect } from 'react'
import { Link, useNavigate, useSearchParams } from 'react-router-dom'
import { AccountSettings, AuthPanel } from '../components/AiAssistant'
import { useAuth } from '../state/AuthContext'

export function AccountPage() {
  const { account } = useAuth()
  const navigate = useNavigate()
  const [params] = useSearchParams()
  const requested = params.get('returnTo') ?? ''
  const returnTo = requested.startsWith('/') && !requested.startsWith('//') ? requested : ''

  useEffect(() => {
    if (account && returnTo) navigate(returnTo, { replace: true })
  }, [account, navigate, returnTo])

  return (
    <div className="page-width page-stack account-page">
      <nav className="breadcrumbs" aria-label="Breadcrumb"><Link to="/">Home</Link><span>›</span><span>Account</span></nav>
      <section className="account-card">
        <span className="eyebrow">Account</span>
        <h1>{account ? 'Your account' : 'Sign in to use AI'}</h1>
        <p>Sign-in and account settings live here. Learning, search, and local progress remain available without an account.</p>
        {account ? <><p>Signed in as {account.email}</p><AccountSettings /><Link className="button primary" to={returnTo || '/ask'}>Continue to AI help</Link></> : <AuthPanel />}
      </section>
    </div>
  )
}
